import { collection, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { getBlob, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../firebase";
import { callPlaqueFunction } from "./vehiclePlaques";

export async function listVehicleArtwork(admin = false) {
  const base = collection(db, "vehicleArtwork");
  const snapshot = await getDocs(admin ? base : query(base, where("status", "==", "approved")));
  return snapshot.docs.map((item) => ({ ...item.data(), id: item.id }));
}

export async function listArtworkVersions(artworkId) {
  const snapshot = await getDocs(collection(db, "vehicleArtwork", artworkId, "versions"));
  const versions = await Promise.all(snapshot.docs.map(async (item) => {
    const source = await getDoc(doc(db, "vehicleArtwork", artworkId, "references", item.id));
    return { ...item.data(), id: item.id, source: source.data() || {} };
  }));
  return versions
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
}

export async function getArtworkVersion(artworkId, version) {
  const snapshot = await getDoc(doc(db, "vehicleArtwork", artworkId, "versions", version));
  if (!snapshot.exists()) throw new Error("Artwork version is unavailable.");
  return { ...snapshot.data(), id: snapshot.id };
}

// Authenticated SDK reads produce local URLs, never shareable download tokens.
export async function artworkObjectUrl(assetPath) {
  return URL.createObjectURL(await getBlob(ref(storage, assetPath), 5 * 1024 * 1024));
}

export async function uploadArtworkVersion({ artworkId, file, sourceUrl, sourceNotes }) {
  if (!file || file.type !== "image/png" || file.size > 5 * 1024 * 1024) {
    throw new Error("Choose a PNG image, 5 MB or smaller. Transparent backgrounds work best.");
  }
  const version = crypto.randomUUID();
  await uploadBytes(ref(storage, `vehicleArtworkDrafts/${artworkId}/${version}/silhouette.png`), file, { contentType: "image/png" });
  return callPlaqueFunction("registerVehicleArtworkVersion", { artworkId, version, sourceUrl, sourceNotes });
}
